import { GiCancel } from "react-icons/gi";
import { GoVerified } from "react-icons/go";

import { BlocoNome, MenuContent, SubTitle } from "../../styles/styles";
import './styles.css'

const InfoPage = ({ img, title , notEdited , edited  } , key) => {
    return (
        <MenuContent key={key}>
            <BlocoNome>
                <img src={img} alt="" />
                <SubTitle>{title}</SubTitle>
            </BlocoNome>
            <div className='info-icone'>
                <div><span>{notEdited}:</span><GiCancel color='red' /> <p>  Não editado</p></div>
                <div><span>{edited}:</span><GoVerified color='green' /> <p>Editado</p></div>
            </div>
        </MenuContent>
    )
}
export default InfoPage